<div class="p-3">
  @if (step == 'enter_abha') {
    <div class="kx-control">
      <label class="required" for="abha_number">{{'field.label.abha_number' | translate | async}}</label>
      <input type="text" class="form-control" id="abha_number" placeholder="Enter ABHA Number"
        [(ngModel)]="abhaNumber" name="abha_number" [disabled]="isSubmitting" (keyup.enter)="sendOtp()" />
    </div>
    <div class="col-12 p-0 mt-3 text-center">
      <button type="button" class="aside-fixed-button primary-btn submitButton" [disabled]="isSubmitting"
        (click)="sendOtp()">
        {{'button.send_otp' | translate | async}} <i class="fa fa-paper-plane" aria-hidden="true"></i>
      </button>
    </div>
  }
  @if (step == 'enter_otp') {
    <div class="mt-2 text-center">
      <p>{{'field.label.Enter_otp' | translate | async}}</p>
    </div>
    <div class="kx-control text-center">
      <input type="text" class="form-control text-center otp-box" maxlength="6" inputmode="numeric"
        pattern="[0-9]*" placeholder="Enter OTP" [(ngModel)]="otp" name="otp" [disabled]="isSubmitting"
        (keyup.enter)="verifyOtp()" />
    </div>
    <div class="col-12 p-0 mt-3 text-center">
      <button type="submit" class="aside-fixed-button primary-btn submitButton"
        [disabled]="isSubmitting || !otp || otp.length < 4" (click)="verifyOtp()">
        {{'button.submit' | translate | async}} <i class="fa fa-check" aria-hidden="true"></i>
      </button>
    </div>
    <div class="col-12 mt-2 p-0 text-center">
      @if (!showTimer) {
        <span style="cursor: pointer; color: #20a8d8;" (click)="resendOtp()">{{'field.button.resend_otp' | translate | async}}</span>
      }
      @if (showTimer) {
        <span style="cursor: not-allowed; color: gray;">{{'field.button.resend_otp' | translate | async}}</span>
        <span class="timer"> {{timer}} sec</span>
      }
    </div>
  }
</div>
